/* Scroll reveal — fades .reveal elements up on entry. Mirrors the wireframe behavior. */
(function () {
  function init() {
    var els = document.querySelectorAll('.reveal:not([data-revealed])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-revealed', ''); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });

    els.forEach(function (el, i) {
      el.setAttribute('data-revealed', '');
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';
      el.style.transition = 'opacity 0.42s ' + (i % 4) * 60 + 'ms ease, transform 0.42s ' + (i % 4) * 60 + 'ms ease';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-scan when the theme editor injects/reorders sections */
  document.addEventListener('shopify:section:load', init);
})();
